module.exports = __webpack_public_path__ + "static/img/Alou-Kuol.92fe5ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alou-Kuol.jpg
// module id = Zncj
// module chunks = 0